import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import ReviewerSetup from "Administrator/routes/Settings/routes/AnnouncementsManager/routes/ReviewerSetup";
import AnnouncementSettings from "Administrator/routes/Settings/routes/AnnouncementsManager/routes/AnnouncementSettings";
import { getRelativePath } from "Utils";

export default store => ({
  path: "announcements-manager",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-announcements-manager" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //   .catch(err => {
    //     throw err;
    //   })
  ),
  onEnter(nextState, replace) {
    if (_.last(nextState.routes).path === "announcements-manager") {
      const route = getNextMenuRoute("ANNOUNCEMENTS_MANAGER");
      if (route) replace(getRelativePath(route));
      else replace(getRelativePath("../"));
    }
  },
  childRoutes: [ReviewerSetup(store), AnnouncementSettings(store)],
});
